import {FC, useMemo} from "react";
import {NewsItemModalProps} from "./types";
import {Modal} from "antd";
import {useForm} from "antd/es/form/Form";
import NewsItemForm from "./components/newsItem-form/NewsItemForm";

const NewsItemModal: FC<NewsItemModalProps> = (props) => {
  const {isModalOpen, toggleModalOpen, isLoading, createNewsHandler, selectedNewsItem, updateNewsHandler} = props
  const [newsForm] = useForm()


  const okButtonHandler = () => {
    newsForm.submit()
  }

  const title = useMemo(() => {
    return selectedNewsItem ? "Редагування новини" : "Створення новини"
  }, [selectedNewsItem])

  return <Modal destroyOnClose style={{top: 20}} width={1000} title={title} open={isModalOpen}
                onCancel={toggleModalOpen} okText="Збереги" onOk={okButtonHandler}>
    <NewsItemForm updateNewsHandler={updateNewsHandler} selectedNewsItem={selectedNewsItem} isModalOpen={isModalOpen}
                  isLoading={isLoading}
                  createNewsHandler={createNewsHandler} form={newsForm}/>
  </Modal>
}

export default NewsItemModal
